<select
  [ngClass]="[cssColor + '-input-decision']"
  *ngIf="data"
  [ngModel]="data.value"
  (change)="doSomething($event.target.value)"
  style="height: 38px; width: 58px; color: white; padding-left: 15px"
>
  <option *ngFor="let c of values" value="{{ c }}">{{ c }}</option>
</select>
